export enum UserType {
  Mentee = 'mentees',
  Mentor = 'mentors',
  All = 'all',
  Coaching = 'coaching'
}

export enum UserRoleType {
  Mentor = 'Mentor',
  Mentee = 'Mentee',
  Coach = 'Coach',
  Coachee = 'Coachee',
  BasicSubscription = 'Basic Subscription'
}


export enum SessionStageType {
  MeetAndGreet = 'Meet And Greet',
  RecurringSession = 'Recurring Session',
  FinalSession = 'Final Session',
  Coaching = 'Coaching Session',
  Individual = 'Individual Session'
}

export enum SessionStatusType {
  Confirmed = 'CONFIRMED',
  Feedback = 'FEEDBACK',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED'
}

export enum MenuTypes {
  Home = 'Home',
  Profile = 'Profile',
  Sessions = 'Sessions',
  Community = 'Community',
  Learning = 'Resources',
  Tasks = 'Tasks',
  FAQ = 'FAQ',
  LogOut = 'Log Out'
}

export enum TaskType {
  FirstSessionAssessment = 'First Session Assessment',
  MidCohortGroupAssessment = 'Mid Cohort Group Assessment',
  FinalGroupAssessment = 'Final Group Assessment',
  PilotGroupCoachingAssessment = 'Pilot Group Coaching Assessment',
  OneOnOneFinalSurvey = 'One on One Final Survey',
  OneOnOneMidCohortSurvey = 'One on One Mid-Cohort Survey'
}

export enum SurveyTargetType {
  All = 'all'
}

export enum SurveyType {
  OnboardingMentee = 'Onboarding Mentee',
  OnboardingMentor = 'Onboarding Mentor',
  MeetAndGreetFeedback = 'Meet and Greet Feedback',
  FinalSurvey = 'Final Survey',
  TermsAndConditionsAgreement = 'Term and Conditions Agreement',
  MidCohortSurvey = 'Mid-Cohort Survey',
  Onboarding = 'Onboarding'

}

export enum Colors {
  ButtonGreen = '#3C7441',
  Text = '#506657',
  TextTabs = '#445349',
  TextElevated = '#6D8976',
  TextElevatedLighter = '#92b69d',
  BackgroundMain = '#F7FCF9',
  BackgroundMainLighter = '#fcfdfc',
  BackgroundDrawer = '#F0F9F1',
  MenuText = '#3C7441',
  SelectedDrawerBackground = '#E8F4E9',
  Active = '#E8F4E9',
  Inactive = '#F1DEE1',
  LogoRed = '#EF3B59',
  DeepRed = '#9D3543'
}

export enum ResourceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ResourcePlacement {
  Homepage = 'Home Page',
  ResourcesPage = 'Resources Page'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  New = 'NEW'
}

export enum GroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum Emails {
  MainEmail = 'team@locelle.com'
}

export enum SessionNotesTemplate {
  GroupNotesTemplate = 'GROUP_NOTES_TEMPLATE',
  OneOnOneNotesTemplate = 'ONE_ON_ONE_NOTES_TEMPLATE'
}

export enum SessionDurationMinutes {
  Thirty = 30,
  FortyFive = 45,
  Sixty = 60,
  Ninety = 90,
  HundredFive = 105,
  HundredTwenty = 120
}